import { useContext } from 'react';

import { FormReadOnlyContext } from '../context';

export function useShowReadOnlyValidationErrors(): boolean {
  return useContext(FormReadOnlyContext).showValidationErrors;
}
